export default "__VITE_ASSET__BkVRVguG__"